export default Object.freeze({
  METADATA: 'metadata',
  FULL_TEXT: 'fulltext',
  ALL: 'all'
})
